function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import styled from '@emotion/styled';
import { Box } from "../box";
import { NeoSystem, NeoSystemProps } from "../../system";
import { compose } from 'styled-system';
var StyledPosition = styled(Box)(compose(NeoSystem.POSITION, NeoSystem.FLEX));
var Position = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(StyledPosition, _extends({}, props, {
    ref: ref
  }));
});
export { Position };
export default Position;